<template>
    <el-tabs v-model="currentTab" type="card" @tab-remove="removeTab" @tab-click="tabClick">
        <el-tab-pane
            style="height: 100%; max-height: 100%;"
            v-for="(item, index) in tabList"
            v-bind:key="item.key"
            :label="item.caption"
            :name="item.key"
            :closable="item.closable">
            <transition name="el-fade-in">
                <keep-alive :include="item.keepAliveComponents">
                    <component v-if="item.routerStack.length" :is="item.routerStack[item.routerStack.length-1].component"></component>
                </keep-alive>
            </transition>
        </el-tab-pane>
<!--        <transition>-->
<!--            <keep-alive :include="keepAliveComponents">-->
<!--                <router-view></router-view>-->
<!--            </keep-alive>-->
<!--        </transition>-->
    </el-tabs>
</template>

<script>
export default {
    name: "TabLayout",
    data()
    {
        return {
            tabList: this.$store.state.layout.tabList,
            //keepAliveComponents: this.$store.state.layout.keepAliveComponents
        }
    },
    methods:
    {
        removeTab(targetName)
        {
            this.$store.dispatch('layout/closeTab', targetName);
        },
        tabClick(target)
        {
            this.$store.dispatch('layout/focusTab', target.name);
        }
    },
    watch:
    {
        // '$route'(to, from)
        // {
        //     console.log('tablayoutto', to, from);
        //     this.$store.dispatch('layout/routeTo', to.fullPath);
        // }
        // '$store.layout.state.currentTab'(var1, var2)
        // {
        //     console.log('currentTab',var1, var2);
        // }
    },
    computed:
    {
        currentTab:
        {
            get: function()
            {
                // console.log('get tab',this.$store.state.layout.currentTab);
                return this.$store.state.layout.currentTab || '/'
            },
            set:  function (path)
            {
                // console.log('set currentTab', path);
                this.$router.push(path);
            }
        },

    }
}
</script>
<style lang="scss">
@import "@/styles/common.scss";
.el-tabs__nav
{
    margin: 5px 10px 0px 10px;
}
.el-main .el-tabs
{
    height: 100%;
    display: flex;
    flex-direction: column;
}
.el-main .el-tabs .el-tabs__content
{
    /*overflow: auto;*/
    /*padding: 20px 0;*/
    /*旧版浏览器需要显示定义高度, 子元素的100% 才能生效*/
    height: calc(100% - 46px);
}
.el-tabs__header {
    margin: 0;
}
.el-main .el-tabs .el-tabs__content .el-tabs__content {
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/index/component/TabLayout.vue